import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MedicalFeeAmount } from '../../../model/medical-fee/medical-fee-amount';
import { MedicalFeePaymentWizardService } from '../../../services/medical-fee/medical-fee-payment-wizard.service';
import { MedicalFeeAmountComponent } from '../../controls/medical-fee/medical-fee-amount/medical-fee-amount.component';

@Component({
  selector: 'app-medical-fee-payment-amount',
  templateUrl: './medical-fee-payment-amount.component.html',
  styleUrls: ['./medical-fee-payment-amount.component.css']
})
export class MedicalFeePaymentAmountComponent implements OnInit {

  medicalFeeAmount: MedicalFeeAmount;
  form: FormGroup;
  @ViewChild('medicalFeeAmount', {static: false}) medicalFeeAmountCtrl: MedicalFeeAmountComponent;

  constructor( private formBuilder: FormBuilder,
               private mfpWizardService: MedicalFeePaymentWizardService ) {

    this.form = this.formBuilder.group({
      MedicalFeeAmount : ['']
    });
  }

  ngOnInit() {

    this.reload();
    this.form.valueChanges
             .subscribe(( value ) => this.mfpWizardService
             .setMedicalFeeAmount( value.MedicalFeeAmount ));
  }

  public reload() {
 
    this.form.patchValue({
      MedicalFeeAmount : this.mfpWizardService.getMedicalFeeAmount()
    });
  }

  public isValid() {

    return this.medicalFeeAmountCtrl.isValid();
  }

}
